'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

require('../listeners/focusStylesListener');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _ButtonConstants = require('../button/ButtonConstants');

var _ShareButton = require('../decorators/ShareButton');

var _ShareButton2 = _interopRequireDefault(_ShareButton);

var _useActive2 = require('../hooks/useActive');

var _useActive3 = _interopRequireDefault(_useActive2);

var _UIIcon = require('../icon/UIIcon');

var _UIIcon2 = _interopRequireDefault(_UIIcon);

var _setupStyledComponents = require('../listeners/setupStyledComponents');

var _UITruncateString = require('../text/UITruncateString');

var _UITruncateString2 = _interopRequireDefault(_UITruncateString);

var _Links = require('../utils/Links');

var _decorators = require('../utils/propTypes/decorators');

var _refObject = require('../utils/propTypes/refObject');

var _refObject2 = _interopRequireDefault(_refObject);

var _tshirtSize = require('../utils/propTypes/tshirtSize');

var _validHref = require('../utils/propTypes/validHref');

var _validHref2 = _interopRequireDefault(_validHref);

var _TabIndex = require('../utils/TabIndex');

var _UnsafeUrl = require('../utils/UnsafeUrl');

var _UIClickable = require('./UIClickable');

var _UIClickable2 = _interopRequireDefault(_UIClickable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

(0, _setupStyledComponents.setupStyledComponents)();

var getUse = function getUse(use) {
  return use && _ButtonConstants.USE_CLASSES[use] ? use : 'secondary';
};

var renderContents = function renderContents(children) {
  var stringBuffer = '';
  var nextChildIndex = 0;
  var childArr = _react.Children.toArray(children);
  return _react.Children.map(children, function (child) {
    nextChildIndex += 1;
    if (child == null) {
      return null;
    }

    // in response to a breaking change in React 0.15
    // (https://facebook.github.io/react/blog/2016/04/07/react-v15.html#no-more-extra-ltspangts)
    // this wraps any bare strings within a <span> to provide a more
    // predictable DOM for applying automatic spacing rules.
    if (typeof child === 'string') {
      stringBuffer += child;
      if (childArr.length < nextChildIndex || typeof childArr[nextChildIndex] !== 'string') {
        var wrappedStringBuffer = _react2.default.createElement(
          'span',
          null,
          stringBuffer
        );
        stringBuffer = '';
        return wrappedStringBuffer;
      } else {
        return null;
      }
    }

    return child;
  });
};

var renderExternalButtonIcon = function renderExternalButtonIcon(external, iconProps) {
  if (!external) return null;

  // Opening links in a new window is an accessibility anti-pattern.
  // To mitigate this, we add accessible text in the icon to warn that
  // the link will be opened in a new window
  // @link http://diveintoaccessibility.info/day_16_not_opening_new_windows.html

  return _react2.default.createElement(_UIIcon2.default, _extends({}, iconProps, {
    'aria-label': _I18n2.default.text('salesUI.UILink.externalTitle'),
    className: iconProps && iconProps.className || 'private-link--external__icon',
    name: 'externalLink'
  }));
};

var renderTruncatedContents = function renderTruncatedContents(truncate, truncateStringProps, truncateTooltip, renderedContents, renderedExternalButtonIcon) {
  return truncate ? _react2.default.createElement(
    _UITruncateString2.default,
    _extends({
      innerClassName: 'private-button__truncate-string',
      useFlex: true,
      fixedChildren: renderedExternalButtonIcon,
      tooltip: truncateTooltip || renderedContents
    }, truncateStringProps),
    _react2.default.createElement(
      'span',
      null,
      renderedContents
    )
  ) : renderedContents;
};

var UIButton = function UIButton(props) {
  var _useNativeButton = props._useNativeButton,
      ariaPressed = props['aria-pressed'],
      __active = props.active,
      autoFocus = props.autoFocus,
      block = props.block,
      buttonRef = props.buttonRef,
      children = props.children,
      className = props.className,
      disabled = props.disabled,
      external = props.external,
      href = props.href,
      iconProps = props.iconProps,
      onClick = props.onClick,
      rel = props.rel,
      responsive = props.responsive,
      size = props.size,
      tabIndex = props.tabIndex,
      target = props.target,
      truncate = props.truncate,
      truncateStringProps = props.truncateStringProps,
      truncateTooltip = props.truncateTooltip,
      use = props.use,
      rest = _objectWithoutProperties(props, ['_useNativeButton', 'aria-pressed', 'active', 'autoFocus', 'block', 'buttonRef', 'children', 'className', 'disabled', 'external', 'href', 'iconProps', 'onClick', 'rel', 'responsive', 'size', 'tabIndex', 'target', 'truncate', 'truncateStringProps', 'truncateTooltip', 'use']);

  var _useActive = (0, _useActive3.default)(props),
      active = _useActive.active,
      onMouseDown = _useActive.onMouseDown,
      onKeyDown = _useActive.onKeyDown,
      onKeyUp = _useActive.onKeyUp,
      onBlur = _useActive.onBlur;

  (0, _react.useEffect)(function () {
    // Simulate autoFocus when rendering a link element
    if (autoFocus && href) {
      buttonRef.current.focus();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var handleClick = function handleClick(evt) {
    // Block click events while disabled, since we don't actually use [disabled] in the DOM.
    if (disabled) {
      evt.preventDefault();
      evt.stopPropagation();
    } else {
      if (onClick) onClick(evt);
    }
  };

  var handleKeyDown = function handleKeyDown(evt) {
    if (onKeyDown) onKeyDown(evt);

    // Ignore keydown events that bubbled up
    if (evt.target !== buttonRef.current) return;

    // If this is an <a> with a click handler, simulate click on Spacebar to be more button-like
    if (onClick && href) {
      if (evt.key === ' ') {
        // Prevent scrolling
        evt.preventDefault();

        if (disabled) {
          evt.stopPropagation();
        } else {
          onClick(evt);
        }
      }
    }
  };

  var shorthandSize = (0, _tshirtSize.toShorthandSize)(size);
  var computedTabIndex = (0, _TabIndex.getTabIndex)(disabled, tabIndex);
  var computedTarget = (0, _Links.getTarget)(external, target);
  var computedUse = getUse(use);

  if (process.env.NODE_ENV !== 'production') {
    (0, _Links.warnIfShouldBeExternal)(external, computedTarget, 'UIButton');
  }

  var renderedContents = renderContents(children);

  var renderedExternalButtonIcon = renderExternalButtonIcon(external, iconProps);

  var wrappedContents = renderTruncatedContents(truncate, truncateStringProps, truncateTooltip, renderedContents, renderedExternalButtonIcon);

  var unstyled = computedUse === 'unstyled';

  var computedClassName = unstyled ? (0, _classnames2.default)(className, _ButtonConstants.USE_CLASSES[computedUse]) : (0, _classnames2.default)('uiButton private-button', _ButtonConstants.USE_CLASSES[computedUse], _ButtonConstants.SIZE_CLASSES[shorthandSize] || _ButtonConstants.SIZE_CLASSES.default, className, {
    'private-button--active': active,
    'private-button--block': block,
    'disabled private-button--disabled': disabled,
    'private-button--non-responsive': !responsive,
    'private-button--non-link': _ButtonConstants.LINK_USES.indexOf(computedUse) === -1
  });

  var commonProps = _extends({}, rest, {
    'aria-disabled': disabled,
    className: computedClassName,
    'data-button-use': computedUse,
    onBlur: onBlur,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    onKeyUp: onKeyUp,
    onMouseDown: onMouseDown,
    ref: buttonRef,
    tabIndex: computedTabIndex
  });

  if (href) {
    var computedRel = (0, _Links.getRel)(rel, computedTarget);
    return (0, _Links.renderSecurityTaggedLink)(href, _react2.default.createElement(
      'a',
      _extends({}, commonProps, {
        href: (0, _UnsafeUrl.getSafeUrl)(href),
        rel: computedRel,
        target: computedTarget
      }),
      wrappedContents,
      truncate || renderedExternalButtonIcon
    ));
  }

  var ButtonComponent = _useNativeButton ? 'button' : _UIClickable2.default;

  if (!_useNativeButton) {
    // Pass buttonRef down directly to the UIClickable
    commonProps.buttonRef = buttonRef;
    delete commonProps.ref;
  }

  return _react2.default.createElement(
    ButtonComponent,
    _extends({}, commonProps, {
      'aria-pressed': ariaPressed != null ? ariaPressed : active || undefined,
      autoFocus: autoFocus,
      disabled: _useNativeButton ? undefined : disabled,
      onKeyDown: onKeyDown
    }),
    wrappedContents
  );
};

UIButton.propTypes = {
  _useNativeButton: _propTypes2.default.bool,
  active: (0, _decorators.hidden)(_propTypes2.default.bool),
  autoFocus: _propTypes2.default.bool,
  'aria-pressed': _propTypes2.default.bool,
  block: _propTypes2.default.bool,
  buttonRef: _refObject2.default,
  children: _propTypes2.default.node,
  disabled: _propTypes2.default.bool.isRequired,
  external: _propTypes2.default.bool.isRequired,
  hovered: (0, _decorators.hidden)(_propTypes2.default.bool),
  href: _validHref2.default,
  iconProps: _propTypes2.default.object,
  responsive: _propTypes2.default.bool.isRequired,
  rel: _propTypes2.default.string,
  size: (0, _tshirtSize.propTypeForSizes)(['xs', 'sm', 'md'], ['default']),
  target: _propTypes2.default.string,
  truncate: _propTypes2.default.bool.isRequired,
  truncateStringProps: _propTypes2.default.object,
  truncateTooltip: _propTypes2.default.node,
  type: _propTypes2.default.oneOf(['button', 'reset', 'submit']).isRequired,
  use: _propTypes2.default.oneOf(Object.keys(_ButtonConstants.USE_CLASSES)).isRequired
};

UIButton.defaultProps = {
  _useNativeButton: true,
  disabled: false,
  external: false,
  responsive: true,
  size: 'md',
  truncate: false,
  type: 'button',
  use: 'secondary'
};

UIButton.displayName = 'UIButton';

exports.default = (0, _ShareButton2.default)(UIButton);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/button/UIButton.js
// module id = 23
// module chunks = 177